export default __webpack_public_path__ + "static/media/celery.cb778148.svg";